export const sortLocationPhones = <T extends { defaultSms?: boolean; displayName?: string; locationPhone: string }>(
  a: T,
  b: T
): number => {
  if (a?.defaultSms) {
    // there should only ever be one default sms phone number per location
    // defaultSms comes first
    return a.defaultSms ? -1 : 1;
  }

  if (b?.defaultSms) {
    // there should only ever be one default sms phone number per location
    // defaultSms comes first
    return b.defaultSms ? 1 : -1;
  }

  const aHasName = !!a.displayName;
  const bHasName = !!b.displayName;
  if (aHasName && bHasName) {
    // Both have displayName, sort alphabetically
    return a.displayName!.localeCompare(b.displayName!);
  }
  if (aHasName && !bHasName) {
    // a with name comes first
    return -1;
  }
  if (!aHasName && bHasName) {
    // b with name comes first
    return 1;
  }
  // Neither has displayName, sort by phone number
  return a.locationPhone.localeCompare(b.locationPhone, undefined, { numeric: true });
};
